import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Analytics } from "@vercel/analytics/react";
import "./index.css";
import App from "./App";
import { ToastProvider } from "./ToastContext";
import BackSoon from "./components/maintenance/BackSoon";

// Obtener el Client ID de Google desde variables de entorno (sin espacios)
const GOOGLE_CLIENT_ID = (process.env.REACT_APP_GOOGLE_CLIENT_ID || '').trim();
const isPlaceholder = /^tu-client-id|your-client-id|xxx\.apps\.googleusercontent\.com$/i.test(GOOGLE_CLIENT_ID);
const hasValidGoogleClientId = GOOGLE_CLIENT_ID.length > 10 && !isPlaceholder;

if (!hasValidGoogleClientId) {
  console.error(
    '[Vissory] Google OAuth: falta el Client ID. Añade en frontend/.env:\n  REACT_APP_GOOGLE_CLIENT_ID=tu-id-real.apps.googleusercontent.com\nLuego reinicia el servidor (yarn start o npm start). Ver GOOGLE_OAUTH_SETUP.md'
  );
}

// Página «Volvemos pronto» activa por defecto; REACT_APP_MAINTENANCE_MODE=false devuelve la plataforma
const MAINTENANCE_MODE = process.env.REACT_APP_MAINTENANCE_MODE !== "false";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  MAINTENANCE_MODE ? (
    <React.StrictMode>
      <BackSoon />
      <Analytics />
    </React.StrictMode>
  ) : (
  <React.StrictMode>
    <BrowserRouter>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID || 'placeholder'}>
        <ToastProvider>
          <App />
          <Analytics />
        </ToastProvider>
      </GoogleOAuthProvider>
    </BrowserRouter>
  </React.StrictMode>
  ),
);
